module.exports = __webpack_public_path__ + "img/6.53ea2c40.png";